export const STEP = {
  ONE: 1,
  TWO: 2
}
